import { schema, normalize } from '@dtvgo/typed-normalizr';
import { EntityName, ContentSourceType } from '../../utils/normalizr/constants.js';
import { ShowEntity, ContentEntity, ScheduleEntity } from '../../utils/normalizr/entities.js';
import '../../utils/normalizr/interfaces.js';
import { typeToEntityName } from '../../utils/normalizr/utils.js';
import 'query-string';
import '@dtvgo/constants';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';

const searchResultsSchema = new schema.Array({
  [EntityName.SHOW]: ShowEntity,
  [EntityName.CONTENT]: ContentEntity,
  [EntityName.SCHEDULE]: ScheduleEntity
}, (result) => {
  if (result.contentSourceId === ContentSourceType.Live) {
    return EntityName.SCHEDULE;
  }
  return typeToEntityName(result.type);
});
function assets(backendAxiosInstance) {
  async function getAssetDetail(assetId, params) {
    const response = await backendAxiosInstance.get(`/contents/v1/assets/${assetId}`, {
      includeLanguage: true,
      params
    });
    response.normalizedData = normalize(response.data, ContentEntity);
    return response;
  }
  async function searchAssets(searchAssetsParams) {
    const response = await backendAxiosInstance.get(
      "/contents/v1/assets/search",
      {
        includeClientType: true,
        includeTimeZone: true,
        params: searchAssetsParams
      }
    );
    response.normalizedData = normalize(
      response.data.contents,
      searchResultsSchema
    );
    return response;
  }
  return {
    getAssetDetail,
    searchAssets
  };
}

export { assets as default };
//# sourceMappingURL=asset.js.map
